/* eslint-disable import/no-cycle */
import { asyncComponent } from '@telus/isomorphic-core'

const Custom404 = process.env.BROWSER
  ? asyncComponent(/* istanbul ignore next */ () => import('./Container'))
  : require('./Container').default

export default Custom404